import { render } from "./PartnerDataServer.vue?vue&type=template&id=59928962"
import script from "./PartnerDataServer.vue?vue&type=script&lang=js"
export * from "./PartnerDataServer.vue?vue&type=script&lang=js"
script.render = render

export default script